<template>
  <v-app-bar
    v-if="!webViewMode"
    id="toolbar"
    class="header-mobile"
    :class="[{ 'move-up': moveHeaderUp }, postBackground ? 'background-post-background color-post-text' : 'background-top-bar-background color-top-bar-text']"
    :height="mobileTopBarHeight"
  >
    <div class="navigation-bar d-flex align-center fill-width mx-4">
      <div class="slot-placeholder slot-placeholder--left" :class="{ 'extra-margin': Boolean($slots['item-right']) && showSearchPlaceholder }">
        <the-button v-if="manageUiDisplayed && $routerState.isRoot" icon href="/manage">
          <i-custom-disciple />
        </the-button>

        <slot v-else name="item-left" />
      </div>
      <slot name="item-middle">
        <div class="title-container" @click="$emit('title-click')">{{ title || configuration.appTitle }}</div>
      </slot>
      <div class="slot-placeholder slot-placeholder--right">
        <slot name="item-right" />
        <the-button v-if="showSearchPlaceholder" icon @click.native="onSearchClick">
          <i-custom-menu-search />
        </the-button>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "pinia"

import { useAppStateStore } from "@/store/appState.js"
import { useUserSessionStore } from "@/store/userSession.js"
import { useConfigurationStore } from "@/store/configuration.js"

import { usePageScroll } from "@/composables/usePageScroll.js"

import { MOBILE_TOP_BAR_HEIGHT } from "@/constants/barHeights.js"

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    fixed: {
      type: Boolean,
      default: false
    },
    scrollAnimation: {
      type: Boolean,
      default: false
    },
    postBackground: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { isScrollDown } = usePageScroll()
    return { isScrollDown }
  },
  data() {
    return {
      isInsideDialog: false,
      mobileTopBarHeight: MOBILE_TOP_BAR_HEIGHT
    }
  },
  computed: {
    ...mapGetters(useConfigurationStore, ["configuration"]),
    ...mapGetters(useAppStateStore, ["webViewMode"]),
    ...mapGetters(useUserSessionStore, ["manageUiDisplayed"]),
    moveHeaderUp() {
      return this.isScrollDown && this.fixed && this.scrollAnimation
    },
    showSearchPlaceholder() {
      if (this.isInsideDialog) {
        return false
      }

      const groupRouteAndRoot = this.$routerState.isRoot && this.$route.name === this.$routes.GROUPS
      const folderRoute = this.$route.name === this.$routes.FOLDER
      const activityFeed = this.$route.name === this.$routes.GROUPS && !this.$route.params.groupId

      return groupRouteAndRoot || activityFeed || folderRoute
    }
  },
  mounted() {
    // NextTick didn't work here
    setTimeout(() => {
      this.isInsideDialog = !this.webViewMode && Boolean(this.$el?.closest(".v-dialog"))
    })
  },
  methods: {
    onSearchClick() {
      this.$eventBus.$emit("reset-search")
      this.$router.push({ name: this.$routes.SEARCH })
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation-bar {
  height: var(--mobile-top-bar-height);
}

.header-mobile {
  :deep(.app-icon) {
    height: 24px;
    width: 24px;

    &.close-icon {
      height: 16px;
      width: 16px;
    }
  }

  /* For not fixed header set z-index that will allow to show box shadow over related content*/
  &.not-fixed {
    position: relative;
    z-index: var(--z-index-top);

    &.not-fixed {
      z-index: var(--z-index-base);
    }
  }
}

#toolbar {
  text-align: left;
  z-index: var(--z-index-headers);
  box-shadow: var(--shadow-2) !important;
  overflow-y: visible;
  transition: var(--bars-transition);

  :deep(img:not(.v-img__img)) {
    height: 32px;
  }

  :deep(.v-toolbar__content) {
    flex-wrap: wrap;
    padding: 0;
    justify-content: flex-start;

    .v-btn {
      &:not(.v-btn--size-small) {
        height: 40px;
        min-width: 40px;
      }
    }
  }

  .slot-placeholder {
    display: flex;
    align-items: center;
    flex-grow: 0;

    &.slot-placeholder--left {
      :deep(.v-btn--icon) {
        margin-left: -8px;
        //to make it equal to the height of the button
        width: unset;
      }

      &.extra-margin {
        margin-right: 20px;
      }
    }

    &.slot-placeholder--right {
      margin-left: auto;
      :deep(.v-btn--icon) {
        margin-right: -8px;
        //to make it equal to the height of the button
        width: unset;
      }
    }
  }

  &.move-up {
    transform: translateY(-100px) !important;
  }

  :deep(.title-container) {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
    width: 100%;
    max-width: 100%;
  }
}
</style>
